import { graphql } from '@/client/services/api/graphql/gql';

export const getEddyStatsQuery = graphql(`
  query GetEddyStats {
    getEddyStats {
      eddyUserCount
      externalPromptCount
      inAppPromptCount
      negativeSentimentCount
      positiveSentimentCount
      __typename
    }
  }
`);
